<template>
  <v-form v-model="valid" ref="form" v-bind="this.$attrs" class="mb-6">
    <v-row>
      <v-col cols="12" md="6" class="pb-0 pb-sm-0">
        <v-text-field
          v-model="phone"
          label="Số điện thoại"
          hide-details="auto"
          outlined
          dense
          required
          class="required"
          :rules="[$rules.phone, $rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="email"
          label="Email"
          hide-details="auto"
          outlined
          dense
          :rules="[$rules.email]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field v-model="currentLive" label="Địa chỉ hiện tại" hide-details="auto" outlined dense></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="pb-0 pb-sm-0 pb-md-3">
        <v-text-field v-model="province" label="Tỉnh/Thành phố" hide-details="auto" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="district" label="Quận/Huyện" hide-details="auto" outlined dense></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import get from 'lodash-es/get'
export default {
  props: {
    student: {
      type: [Object],
      default: () => {},
    },
  },
  data: () => ({
    valid: true,
    currentLive: '',
    province: '',
    district: '',
    phone: '',
    email: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 6 || 'Min 8 characters',
      email: (v) => /.+@.+/.test(v) || 'E-mail must be valid',
    },
  }),
  created() {
    if (this.student) {
      this.currentLive = get(this.student, 'data.currentLive')
      this.province = get(this.student, 'data.province')
      this.district = get(this.student, 'data.district')
      this.phone = this.student.phone
      this.email = this.student.email
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        currentLive: this.currentLive,
        province: this.province,
        district: this.district,
        phone: this.phone,
        email: this.email,
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped></style>
